import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import FolderSource from 'sources/inbox/FolderSource';

class FolderActions {
  constructor() {
    this.generateActions(...generateAsyncActions('fetchFolders', 'createFolder', 'deleteFolder'));
  }
  fetchFolders() {
    return dispatch => {
      dispatch();
      return FolderSource.fetchFolders().then(this.fetchFoldersSuccess, error => {
        this.fetchFoldersError(error);
        throw error;
      });
    };
  }
  createFolder(folder) {
    return dispatch => {
      dispatch(folder);
      return FolderSource.createFolder(folder).then(this.createFolderSuccess);
    };
  }
  deleteFolder(folderId) {
    return dispatch => {
      dispatch(folderId);
      return FolderSource.deleteFolder(folderId).then(() => this.deleteFolderSuccess(folderId));
    };
  }
}

export default alt.createActions(FolderActions);
